import { render, staticRenderFns } from "./ScriptCreate.vue?vue&type=template&id=6816d825&scoped=true&"
import script from "./ScriptCreate.vue?vue&type=script&lang=js&"
export * from "./ScriptCreate.vue?vue&type=script&lang=js&"
import style0 from "./ScriptCreate.vue?vue&type=style&index=0&id=6816d825&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6816d825",
  null
  
)

export default component.exports